/* eslint-disable no-console*/
import { onError } from '@apollo/client/link/error'

import { logger } from '@/utils/sendToLogger'

const ignoredErrorQueries = ['geocodeReverseFromIp']

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      const error = `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
        locations
      )}, Path: ${path}`
      if (!ignoredErrorQueries.includes(path?.[0] as string)) {
        logger.captureMessage(error, 'error')
        console.error(error)
      }
    })
  }

  if (networkError) {
    console.warn(`[Network error]: ${networkError}`)
  }
})

export default errorLink
